import { render, staticRenderFns } from "./WfDevPublishMsgForm.vue?vue&type=template&id=3eaec838&"
import script from "./WfDevPublishMsgForm.vue?vue&type=script&lang=js&"
export * from "./WfDevPublishMsgForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports